import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

export type QuickStartLinkSignature = {
  Args: {
    route: string;
    icon: string;
    title: string;
    description: string;
    /**
     * Lays the card out horizontally — icon, text, then a trailing arrow — for use
     * as a single full-width link rather than one of a row of three.
     */
    wide?: boolean;
  };
  Element: HTMLDivElement;
};

export const QuickStartLink = <template>
  <div
    class="card border shadow-sm rounded-4 position-relative overflow-hidden"
    ...attributes
  >
    <div
      class="card-body p-3 p-md-4
        {{if
          @wide
          'd-flex flex-column flex-sm-row align-items-sm-center gap-3'
        }}"
    >
      <span
        class="{{if
            @wide
            'll-avatar-sm rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center flex-shrink-0'
            'd-block mb-3'
          }}"
      >
        <iconify-icon
          inline
          icon={{@icon}}
          class="fs-3 {{unless @wide 'text-primary'}}"
          aria-hidden="true"
        />
      </span>

      <div class="{{if @wide 'flex-grow-1 min-w-0'}}">
        <h3 class="h6 fw-bold mb-2"><LinkTo
            @route={{@route}}
            class="stretched-link text-primary"
          >{{@title}}{{#unless @wide}}
              <iconify-icon
                inline
                icon="ph:arrow-right-bold"
                aria-hidden="true"
              />{{/unless}}</LinkTo></h3>
        <p class="card-text mb-0 text-body-secondary small">{{@description}}</p>
      </div>

      {{#if @wide}}
        <iconify-icon
          inline
          icon="ph:arrow-right-bold"
          class="text-primary fs-5 flex-shrink-0 ms-2"
          aria-hidden="true"
        />
      {{/if}}
    </div>
  </div>
</template> satisfies TOC<QuickStartLinkSignature>;
